import { Component, ChangeDetectionStrategy } from "@angular/core";
import { AdminApiService } from "@shared/services/admin/admin-api.service";
import { FE_DimensionConfig } from "@shared/models/admin-responses";
import { ToasterService } from "@shared/services/toaster.service";
import { AdminLogoutConfirmationDialogComponent, } from "./logout-confirmation/logout-confirmation.component";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SpinnerComponent } from "../../elements/spinner/spinner.component";
import { IboxComponent } from "../../elements/ibox/ibox.component";
import { LogService } from "@shared/services/log.service";


@Component({
    templateUrl: "./home.component.html",
    styleUrls: ["./home.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SpinnerComponent, IboxComponent, TranslatePipe]
})
export class AdminHomeComponent {

    public isLoading = true;
    public config: FE_DimensionConfig;

    constructor(
        private readonly adminApi: AdminApiService,
        private readonly toaster: ToasterService,
        private readonly  modal: NgbModal,
        public translate: TranslateService,
        private readonly logService: LogService,
    ) {
        this.translate = translate;
        adminApi.getConfig().then(config => {
            this.config = config;
            this.isLoading = false;
        });
    }

    public logoutAll(): void {
        const selfhostedRef = this.modal.open(AdminLogoutConfirmationDialogComponent, {
            backdrop: 'static'
        });
        selfhostedRef.result.then(async () => {
            try {
                await this.adminApi.logoutAll();
                this.translate.get('Everyone has been logged out').subscribe((res: string) => {
                    this.toaster.pop("success", res);
                });
                this.config.sessionInfo.numTokens = 0;
            } catch (err) {
                this.logService.error(err);
                this.translate.get('Error logging everyone out').subscribe((res: string) => {
                    this.toaster.pop("error", res);
                });
            }
        });
    }
}
